import { api } from './client'

export type AgriCategory = 'fertilizer' | 'pesticide'
export type AgriUnit = 'kg' | 'bag' | 'bottle' | 'pack'
export type AgriTrackingMode = 'lot' | 'quantity'

export interface AgriculturalMaterial {
    id: string
    name: string
    category: AgriCategory
    unit: AgriUnit
    image_url?: string | null
    notes?: string | null
    is_active: boolean
    tracking_mode: AgriTrackingMode
    // is_external: "vật tư ngoài" — hàng hộ trồng tự mua, HTX không nhập/xuất
    // và không giữ tồn. false = vật tư của HTX.
    is_external: boolean
    // grower_ids: vật tư ngoài này dùng cho những hộ nào (chỉ có khi is_external).
    grower_ids?: string[]
    // Định lượng (khớp hệ cũ, text tự do, tùy chọn).
    package_weight?: string | null // khối lượng mỗi bao/đơn vị (vd "30 kg")
    dosage?: string | null // liều lượng (vd "350-450ml/ha")
    quarantine_period?: string | null // thời gian cách ly (vd "3 ngày")
    stock_available?: number
    created_at: string
    updated_at: string
}

export interface ListAgriculturalMaterialsParams {
    search?: string
    category?: AgriCategory
    /** Lọc theo trạng thái is_active; bỏ trống = tất cả (cả đã tắt). */
    is_active?: boolean
    /** Chỉ lấy vật tư HTX + vật tư ngoài đã gán cho hộ này. Tài khoản hộ chỉ
     *  được hỏi hộ của chính mình — hỏi hộ khác server trả 403. Bỏ trống: admin
     *  thấy toàn bộ danh mục, tài khoản hộ thấy gộp các hộ của mình. */
    grower_id?: string
    page?: number
    per_page?: number
}

export interface CreateAgriculturalMaterialRequest {
    name: string
    category: AgriCategory
    unit: AgriUnit
    image_url?: string | null
    notes?: string | null
    is_active: boolean
    tracking_mode: AgriTrackingMode
    is_external: boolean
    grower_ids?: string[]
    package_weight?: string | null
    dosage?: string | null
    quarantine_period?: string | null
}

export type UpdateAgriculturalMaterialRequest =
    CreateAgriculturalMaterialRequest

export const agriculturalMaterialsApi = {
    list: (params?: ListAgriculturalMaterialsParams) =>
        api.get<AgriculturalMaterial[]>('/agricultural-materials', {
            params: params as Record<
                string,
                string | number | boolean | undefined
            >,
        }),
    get: (id: string) =>
        api.get<AgriculturalMaterial>(`/agricultural-materials/${id}`),
    create: (data: CreateAgriculturalMaterialRequest) =>
        api.post<AgriculturalMaterial>('/agricultural-materials', data),
    update: (id: string, data: UpdateAgriculturalMaterialRequest) =>
        api.put<AgriculturalMaterial>(`/agricultural-materials/${id}`, data),
    remove: (id: string) => api.delete<void>(`/agricultural-materials/${id}`),
}
